import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import CheckboxField from '../../../../../../../Inputs/CheckboxField';
import useIntakeBlockToggle, {
  intakeBlocksEnum,
} from '../../../../hooks/useIntakeBlockToggle';
import { FormControl, FormControlLabel } from '@mui/material';
import styles from '../index.module.scss';

const POAField = () => {
  const { control } = useFormContext();
  const { isOn } = useIntakeBlockToggle();

  if (!isOn(intakeBlocksEnum.poa)) {
    return null;
  }

  return (
    <FormControl>
      <Controller
        name="poa"
        control={control}
        defaultValue={false}
        render={({ field }) => (
          <FormControlLabel
            control={
              <CheckboxField
                name="poa"
                inputRef={field.ref}
                checked={!!field.value}
                onChange={field.onChange}
                classes={{
                  root: styles.checkbox,
                  checked: styles.checked,
                }}
              />
            }
            label={`Patient is using a phone that belongs to a power of attorney (POA),
        or other authorized person. (This means background data will not be
        collected)`}
            className={styles.checkboxLabel}
          />
        )}
      />
    </FormControl>
  );
};

export default POAField;
